export default __webpack_public_path__ + "static/Wingspans-homepage-dashboard-78798bac990b3dc931ea326a6c57018d.jpg";